import { useState } from 'react'
import { Check, Copy, SearchX, Users } from '@/lib/icons'
import { Button } from '@/components/ui/button'

/**
 * Bot username `VITE_BOT_USERNAME` orqali beriladi (`apps/webapp/.env`).
 *
 * Zaxira qiymat — HAQIQIY bot username'i. Ilgari bu yerda hujjatdagi namuna qiymat
 * (`@AyubBookBot`) qattiq yozilgan edi va u mavjud bo'lmagan botga havola berardi:
 * admin havolani nusxalab tarqatsa, blogerlar bo'sh sahifaga tushardi.
 */
const BOT_USERNAME_RAW = import.meta.env.VITE_BOT_USERNAME ?? 'ayubnashrbot'
const BOT_USERNAME = `@${BOT_USERNAME_RAW}`
const BOT_LINK = `https://t.me/${BOT_USERNAME_RAW}`

/**
 * Birinchi kun holati — hali umuman bloger yo'q (`docs/03-app-flow.md`, "Bo'sh holatlar").
 */
export function BloggersFirstRunEmptyState() {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    void navigator.clipboard.writeText(BOT_LINK).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1800)
    })
  }

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-app-card p-4">
        <Users size={28} className="text-app-hint" aria-hidden="true" />
      </div>
      <h2 className="text-base font-semibold">Hali bloger yo'q</h2>
      <p className="max-w-xs text-sm text-app-hint">
        Botni tarqating: <span className="font-medium text-app-text">{BOT_USERNAME}</span>
      </p>
      <Button variant="secondary" size="sm" onClick={handleCopy}>
        {copied ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
        {copied ? 'Nusxalandi' : 'Havolani nusxalash'}
      </Button>
    </div>
  )
}

interface NoResultsEmptyStateProps {
  searchTerm: string
  onClearFilters: () => void
}

/**
 * Qidiruv/filtr hech narsa bermagan holat (`docs/03-app-flow.md`, "Bo'sh holatlar":
 * "«{so'z}» bo'yicha topilmadi" + [Filtrni tozalash]).
 */
export function BloggersNoResultsEmptyState({
  searchTerm,
  onClearFilters,
}: NoResultsEmptyStateProps) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-app-card p-4">
        <SearchX size={28} className="text-app-hint" aria-hidden="true" />
      </div>
      <p className="max-w-xs text-sm text-app-text">
        {searchTerm.length > 0 ? (
          <>
            «<span className="font-medium">{searchTerm}</span>» bo'yicha topilmadi
          </>
        ) : (
          "Bu bosqichda bloger yo'q"
        )}
      </p>
      <Button variant="secondary" size="sm" onClick={onClearFilters}>
        Filtrni tozalash
      </Button>
    </div>
  )
}

/** Kanban ustuni bo'sh holati — `docs/03`: "Bu bosqichda video yo'q" + kulrang ikonka (bloger uchun moslashtirilgan). */
export function BloggerKanbanColumnEmptyState() {
  return (
    <div className="flex flex-col items-center gap-2 rounded-card border border-dashed border-app-border px-3 py-6 text-center">
      <Users size={20} className="text-app-hint" aria-hidden="true" />
      <p className="text-xs text-app-hint">Bu bosqichda bloger yo'q</p>
    </div>
  )
}
